// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__35a72","range":"MonthRangeSwitch_range__32UkR","disabled":"MonthRangeSwitch_disabled__3bncL"};